import useProductStore from '@/store/product.store';
import useAnimationControl from '@/composables/useAnimationControl';
import useConfigStore from '@/store/config.store';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import type { IField } from '@/typescript/interfaces/IField';

function useField(fieldId: string) {
    const productStore = useProductStore();
    const { displayBatImage } = storeToRefs(useConfigStore());
    const { stopAnimation } = useAnimationControl();
    const { selectedFieldId } = storeToRefs(productStore);
    const initialField = ref<IField>();

    const isFormVisible = computed(() => selectedFieldId.value === fieldId);

    function hideForm() {
        selectedFieldId.value = undefined;
    }

    function showForm() {
        stopAnimation();
        selectedFieldId.value = fieldId;
        displayBatImage.value = false;
    }

    function deleteField(field: IField) {
        productStore.removeField(field);
    }

    function toggleLock(field: IField) {
        const fieldToEdit = { ...field };
        fieldToEdit.editable = !field.editable;
        productStore.updateField(fieldToEdit);
    }

    function setInitialField(field: IField) {
        initialField.value = JSON.parse(JSON.stringify(field));
    }

    function resetField() {
        if (!initialField.value) {
            return;
        }
        productStore.updateField(initialField.value);
    }

    function duplicateField(field: IField) {
        const newField: IField = JSON.parse(JSON.stringify({ ...field, id: crypto.randomUUID() }));

        newField.transform.position.x += 100;
        newField.transform.position.y += 100;

        productStore.addField(newField);
    }

    return { isFormVisible, showForm, hideForm, deleteField, toggleLock, duplicateField, setInitialField, resetField };
}

export default useField;
